import { io } from 'socket.io-client';
import { SOCKET_BASE_URL } from '@/config/api';

let socketInstance = null;

/**
 * Centralized Socket.IO service.
 * Manages a single socket connection shared across the app.
 */
export const socketService = {
  connect(userId, socketUUID) {
    if (socketInstance?.connected) {
      return socketInstance;
    }

    socketInstance = io(SOCKET_BASE_URL);
    socketInstance.emit('addUser', {
      userId,
      ip_address: socketUUID,
    });

    return socketInstance;
  },

  getSocket() {
    return socketInstance;
  },

  emit(receiverId, emitRequest) {
    if (socketInstance) {
      socketInstance.emit('sendNotify', {
        receiver_id: receiverId,
        snackbar: emitRequest.snackbar,
      });
    }
  },

  on(event, handler) {
    if (socketInstance) {
      socketInstance.on(event, handler);
    }
  },

  off(event, handler) {
    if (socketInstance) {
      socketInstance.off(event, handler);
    }
  },

  disconnect() {
    if (socketInstance) {
      socketInstance.disconnect();
      socketInstance = null;
    }
  },
};

export default socketService;
